/* CRAB CREW LIFE — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  const menuBtn = document.querySelector('.header-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      mobileNav.classList.toggle('is-open');
      document.body.classList.toggle('menu-open');
    });
  }

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 40px rgba(0,0,0,0.6)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  // Cart count from Shopify AJAX
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    })
    .catch(() => {});

  // Add to cart AJAX
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => { window.location.href = '/cart'; })
        .catch(err => console.error(err));
    });
  });

  // Newsletter form
  const newsletter = document.querySelector('.newsletter-form');
  if (newsletter) {
    newsletter.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]').value;
      const btn = this.querySelector('button');
      btn.textContent = 'SUBSCRIBED';
      btn.disabled = true;
    });
  }

  // Scroll-triggered fade-in
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

});
